const initialiseCheckoutPage = () => {
  const isCheckoutPage = document.body.classList.contains("checkout-onepage-index");
  document.addEventListener("DOMContentLoaded", () => {
    if (isCheckoutPage) {
      import("./AddressFinderWidget").then((loadedModule) => {
        const AddressFinderWidget = loadedModule.default();
        AddressFinderWidget.initialise();
      });
    }
  });
};

export { initialiseCheckoutPage };
